export default __webpack_public_path__ + "static/media/logo.e0514c8b.png";